module.exports = __webpack_public_path__ + "img/venteny.a13700af.jpg";